// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientAccountPatientRegistrationIPatientRegistrationData } from './patientAccountPatientRegistrationIPatientRegistrationData.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientAccountPatientAccountPatientRegistrationDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': PatientAccountPatientRegistrationIPatientRegistrationData | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientAccountPatientAccountPatientRegistrationDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PatientAccountPatientRegistrationIPatientRegistrationData"
        },
    ];

    static getAttributeTypeMap() {
        return PatientAccountPatientAccountPatientRegistrationDefaultResponse.attributeTypeMap;
    }
}
